import { getLocalDateTimeStartOfDay } from '@wix/bookings-catalog-calendar-viewer-utils/dateAndTime';
import { AsyncComponentDataStatus } from '../../state/types';
import { DailyAgendaActionFactory } from '../actions';
import { initSlots } from '../../../../adapters/initWidgetData/initSlots/initSlots';

export const createOnDaySelectedAction: DailyAgendaActionFactory<
  (selectedDay: string) => Promise<void>
> =
  ({ setState, getState, flowAPI }) =>
  async (selectedDay) => {
    const { selectedDate: prevSelectedDay } = getState();
    const newSelectedDate = new Date(selectedDay);
    if (
      getLocalDateTimeStartOfDay(prevSelectedDay) ===
      getLocalDateTimeStartOfDay(newSelectedDate)
    ) {
      return;
    }

    setState({
      slotsMetaData: { status: AsyncComponentDataStatus.LOADING },
      slots: { status: AsyncComponentDataStatus.LOADING },
      selectedDate: newSelectedDate,
    });

    await initSlots({ flowAPI, setState, getState });
  };
